import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  public showLocation = false;
  public initialized = false;
  public currentPosition: GeolocationPosition | undefined;

  public getLocation() {
    if (!this.initialized) {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition, this.showError);
      } else {
        this.showLocation = false;
      }
    }
    this.initialized = true;

    return this.currentPosition;
  }

  private showPosition = (position: any) => {
    this.showLocation = true;
    this.currentPosition = position;
  }

  private showError = (error: any) => {
    this.showLocation = false;
  }
}
